import { render } from "./Roldisleben.vue?vue&type=template&id=3127d411"
import script from "./Roldisleben.vue?vue&type=script&lang=js"
export * from "./Roldisleben.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__